module.exports = __webpack_public_path__ + "static/clearfix-bbe17ac1876e5be4efae1f348b6a69f4.jpg";